export const WEBSOCKET = "WebSocketService";
